import site from "../../content/site.json";

export function Footer() {
  return (
    <footer id="inquiries" className="studio-footer scroll-mt-20">
      <div className="studio-footer-top"><p>Bookings & inquiries</p><span>Message me on Instagram</span><span>Kern County, California</span></div>
      <a className="studio-footer-contact" href={site.instagram} target="_blank" rel="noopener noreferrer">@capturesby_mari <span aria-hidden>↗</span></a>
      <div className="studio-footer-bottom"><span>© {new Date().getFullYear()} {site.studioName}</span><span>All photographs by Mari</span><a href="#top" onClick={(event) => { event.preventDefault(); window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" }); }}>Back to top ↑</a></div>
    </footer>
  );
}
